import { Link } from 'react-router-dom';
import { categories } from '@/mocks/articles';

export default function CategoryGrid() {
  return (
    <section className="py-14 md:py-20 px-4 md:px-6">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-12">
          <span className="inline-block px-3 py-1 border border-foreground-200 text-foreground-600 text-xs rounded-full mb-4 whitespace-nowrap">
            爆料分类
          </span>
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-3">
            全维度追踪，不错过每一个瓜
          </h2>
          <p className="text-sm text-foreground-500 max-w-lg mx-auto">
            四大核心板块覆盖吃瓜全场景，你想看的这里都有
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group p-6 rounded-xl bg-background-50 border border-background-200/70 hover:bg-primary-500 hover:border-primary-500 transition-all duration-300 cursor-pointer"
            >
              <div className="w-12 h-12 flex items-center justify-center bg-background-100 rounded-lg mb-4 group-hover:bg-white/20 transition-colors">
                <i className={`${cat.icon} text-xl text-primary-500 group-hover:text-white transition-colors`}></i>
              </div>
              <h3 className="text-lg font-heading font-bold text-foreground-900 group-hover:text-white mb-2 transition-colors">
                {cat.name}
              </h3>
              <p className="text-sm text-foreground-500 group-hover:text-white/80 transition-colors leading-relaxed mb-3">
                {cat.description}
              </p>
              <span className="inline-flex items-center gap-1 text-sm text-primary-500 group-hover:text-white transition-colors whitespace-nowrap">
                浏览更多
                <i className="ri-arrow-right-line text-xs"></i>
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}